/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import './editor.all';
import './standalone/browser/iPadShowKeyboard/iPadShowKeyboard';
import './standalone/browser/inspectTokens/inspectTokens';
import './standalone/browser/quickAccess/standaloneHelpQuickAccess';
import './standalone/browser/quickAccess/standaloneGotoLineQuickAccess';
import './standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess';
import './standalone/browser/quickAccess/standaloneCommandsQuickAccess';
import './standalone/browser/referenceSearch/standaloneReferenceSearch';
import './standalone/browser/toggleHighContrast/toggleHighContrast';

export * from './editor.api';
